import { Image, ImageProps } from 'theme-ui'

const Origin = (props: ImageProps) => {
  return (
    <Image width={16} src="https://storage.reserve.org/origin.svg" {...props} />
  )
}
export default Origin
